module.exports = __webpack_public_path__ + "media/images/key-icon-dd819e552d5f0d298d189f2ad887794b.svg";